import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog } from '@angular/material/dialog';
import { ImportTemplateComponent } from 'src/app/core/dialogs/import-template/import-template.component'
import { Constants } from 'src/app/constants';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component'
import { AddHomeComponent } from 'src/app/core/dialogs/add-home/add-home.component'
import { RunReportComponent } from 'src/app/core/dialogs/run-report/run-report.component'
import { ExcelService } from 'src/app/service/excel.service';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { HomeService } from 'src/app/service/home.service';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {

  gridApi: any;
  icons;
  columnDefs;
  displayRowData = [];
  context: any;
  gridOptions: any
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  successMessage;
  errorMessage;
  userId: any;
  costCentreDrpDown = [];
  domicileDrpDwn = [];
  reasonIdDrpDwn = [];
  carrierDropDown: any;
  runReasonDropDown: any
  runPeriodDropDown: any
  runDomicileDropDown: any
  totalRecords = 0; 
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
    {value: 10 , selected : false},
		{value: 20 , selected : false},
		{value: 30 , selected : true},
		{value: 50 , selected : false},
	]
	originalPage: any;
  paginationPageSize: number = 30;
  dynamicHeight: number;
  constructor(public dialog: MatDialog, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants,
    private readonly homeService: HomeService, private readonly excelService: ExcelService, private readonly eboiStateService: EboiStateService,
  ) {
    this.context = {
      componentParent: this
    };

    this.gridOptions = {
      suppressCellSelection: true,
      context: this.context,
    }
  }

  ngOnInit(): void {
    // this.checkRoles();
    this.dynamicHeight = 0.665 * (window.innerHeight) - 50;
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.columnDefs = [
      {
        headerName: "Load Number", autoHeight: true, wrapText: true, minWidth: 120, maxWidth: 120, field: "loadNumber",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true,
      },
      {
        headerName: "Expedite Date", autoHeight: true, wrapText: true, field: "expediteDate", minWidth: 120, maxWidth: 120,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
        unSortIcon: true, sortable: true, comparator: this.dateComparator
      },
      {
        headerName: "Route Date", autoHeight: true, wrapText: true, field: "routeDate",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Route", autoHeight: true, wrapText: true, field: "route", minWidth: 80, maxWidth: 80,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Run", autoHeight: true, wrapText: true, field: "run", minWidth: 50, maxWidth: 50,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Mileage", autoHeight: true, wrapText: true, field: "mileage", minWidth: 80, maxWidth: 80
      },
      {
        headerName: "Cost Center", autoHeight: true, wrapText: true, field: "costCentre",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Allocation Rate", autoHeight: true, wrapText: true, field: "allocationRate", minWidth: 122, maxWidth: 122,
      },
      {
        headerName: "Total Cost", autoHeight: true, wrapText: true, field: "totalCost"
      },
      {
        headerName: "Domicile", autoHeight: true, wrapText: true, field: "domicile", minWidth: 90, maxWidth: 90,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Reason ID", autoHeight: true, wrapText: true, field: "reasonId", minWidth: 90, maxWidth: 90,
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agNumberColumnFilter',
      },
      {
        headerName: "Vendor", autoHeight: true, wrapText: true, field: "carrier",
        floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, filter: 'agTextColumnFilter',
      },
      {
        headerName: "Actions", autoHeight: true, wrapText: true, field: "home", cellRenderer: BtnCellRendererEditDelete
      }
    ]
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.homeDropDownData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);

  }

  async checkRoles() {
    await this.eboiStateService.getRoles();
    const roles = this.eboiStateService.getroleState();
    // const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (!(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
    //   || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))) {
    //   if (!userRoles.includes(this.constants.LIOS_UAC_LP_Filter))
    //     window.location.replace(this.constants.LIOSMainPortalURL);
    // }  // Commented for APM integration
  }

  async homeDropDownData() {
    await this.homeService.costCenterDrpDwn().then(x => {

      if (x && x.length > 0) {
        this.costCentreDrpDown = [];
        x.forEach(element => {
          this.costCentreDrpDown.push({ label: element, value: element })
        });
      }
    })

    await this.homeService.domicileDrpDwn().then(x => {

      if (x && x.length > 0) {
        this.domicileDrpDwn = [];
        x.forEach(element => {
          this.domicileDrpDwn.push({ label: element, value: element })
        });
      }
    })

    await this.homeService.reasonIdDrpDwn().then(x => {

      if (x && x.length > 0) {
        this.reasonIdDrpDwn = [];
        x.forEach((obj, _index) => {
          this.reasonIdDrpDwn.push({ label: obj, value: obj })
        });
      }
    })

    await this.homeService.carrierDrpDwm().then(x => {

      if (x && x.length > 0) {
        this.carrierDropDown = [];
        x.forEach((obj, _index) => {
          this.carrierDropDown.push({ label: obj, value: obj })
        });
      }
    })

    await this.homeService.runReasonDropDown().then(x => {

      if (x && x.length > 0) {
        this.runReasonDropDown = [];
        x.forEach((obj, _index) => {
          this.runReasonDropDown.push({ label: obj.item_desc, value: obj.item_desc })
        });
      }
    })

    await this.homeService.runPeriodDropDown().then(x => {

      if (x && x.length > 0) {
        this.runPeriodDropDown = [];
        x.forEach((obj, _index) => {
          this.runPeriodDropDown.push({ label: obj.period, value: obj.periodId })
        });
      }
    })

    await this.homeService.runDomicileDropDown().then(x => {

      if (x && x.length > 0) {
        this.runDomicileDropDown = [];
        x.forEach((obj, _index) => {
          this.runDomicileDropDown.push({ label: obj.logisticspointcode, value: obj.logisticspointcode })
        });
      }
    })

    this.refreshData()
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  addTemplate() {
    const dialogRef = this.dialog.open(
      AddHomeComponent, {
      disableClose: true,
      width: '520px',
      data: {
        header: 'ADD EXPEDITE',
        eventType: 'ADD',
        domicileDrpDwn: this.domicileDrpDwn,
        reasonIdDrpDwn: this.reasonIdDrpDwn,
        costCentreDrpDown: this.costCentreDrpDown,
        carrierDropDown: this.carrierDropDown,
        userId: this.userId
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        if (result.resmsg == 'warning-msg') { // NOSONAR
          this.successMessage = this.constants.APIDataSaved + "      WARNING! - Expedite Date should be on or after Route Date.";
        } else {
          this.successMessage = this.constants.APIDataSaved;
        }
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }

  editTemplateRow(data) {
    const dialogRef = this.dialog.open(
      AddHomeComponent, {
      disableClose: true,
      width: '520px',
      data: {
        header: 'EDIT FORM',
        eventType: 'EDIT',
        domicileDrpDwn: this.domicileDrpDwn,
        reasonIdDrpDwn: this.reasonIdDrpDwn,
        costCentreDrpDown: this.costCentreDrpDown,
        carrierDropDown: this.carrierDropDown,
        userId: this.userId,
        loadNumber: data.loadNumber,
        expDate: data.expediteDate,
        routeDate: data.routeDate,
        route: data.route,
        run: data.run,
        mileage: data.mileage,
        costCentre: data.costCentre,
        allocationRate: data.allocationRate,
        totalCost: data.totalCost,
        domicile: data.domicile,
        reasonId: data.reasonId,
        carrier: data.carrier,
        routeId: data.routeId
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.resmsg == 'warning-msg') { // NOSONAR
          this.successMessage = this.constants.APIDataSaved + "      WARNING! - Expedite Date should be on or after Route Date.";
        } else {
          this.successMessage = this.constants.APIDataSaved;
        }
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();
      }
    });
  }

  runReportTemplate() {
    const dialogRef = this.dialog.open(
      RunReportComponent, {
      disableClose: true,
       width: '500px',
      data: {
        header: 'RUN REPORT',
        runPeriodDropDown: this.runPeriodDropDown,
        runDomicileDropDown: this.runDomicileDropDown,
        runReasonDropDown: this.runReasonDropDown,
        userId: this.userId
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = "Daily Cubeout Report Submitted Successfully. Please Check History Tab to Download File."
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    });
  }

  // emptyTemplate() {
  //   this.ngxUiLoaderService.start(this.constants.LoaderComponent)
  //   this.homeService.downloadTemplate().subscribe(
  //     response => {
  //       this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  //       if (response?.size >= 1) {
  //         let fileName = `EBOI TEMPLATE${EXCEL_EXTENSION}`;

  //         const data: Blob = new Blob([response], { type: EXCEL_TYPE });
  //         saveAs(data, fileName);
  //       }
  //       else {
  //         this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  //         this.errorMessage = this.constants.APIErrorMessage;
  //         setTimeout(() => {
  //           this.successMessage = "";
  //           this.errorMessage = "";
  //         }, this.constants.notificationMessageTimeShort);
  //       }

  //     }, error => {
  //       this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  //       this.errorMessage = this.constants.APIErrorMessage;
  //       setTimeout(() => {
  //         this.successMessage = "";
  //         this.errorMessage = "";
  //       }, this.constants.notificationMessageTimeShort);

  //     }
  //   )
  // }

  async emptyTemplate() {
    const fileName = 'EBOI/EBOI_TEMPLATE.xlsx';

    if (!fileName) {
      console.info('File name is empty');
      return;
    }
    const fullUrl = `${environment.TEMPLATE_EXCEL_URI}/${fileName}`;
    await this.download(fullUrl, fileName);
  }

  async download(fullUrl: string, fileName: string) {
    if (!fullUrl || !fileName) {
      console.info('File name is empty');
      return;
    }

    const accessToken = sessionStorage.getItem('accessToken');
    if (!accessToken) {
      this.errorMessage = 'Missing authentication token. Please sign in again.';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, this.constants.notificationMessageTimeShort);
      return;
    }

    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    try {
      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'x-auth-token': accessToken
        }
      });

      if (!response.ok) {
        throw new Error(`Template download failed with status ${response.status}`);
      }

      const data = await response.blob();
      const downloadName = fileName.split('/').pop() || 'downloaded_file';
      saveAs(data, downloadName);
    } catch (error) {
      console.info('Template download failed', error);
      this.errorMessage = this.constants.APIErrorMessage;
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, this.constants.notificationMessageTimeShort);
    } finally {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    }
  }

  importValidate() {
    const dialogRef = this.dialog.open(
      ImportTemplateComponent, {
      disableClose: true,
      width: '800px',
      data: {
        userId: this.userId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.status == true) { // NOSONAR
        this.refreshData()
      }
    });
  }

  deleteTemplateRow(data) {
    const dialogRef = this.dialog.open(
      DeleteDialogComponent, {
      disableClose: true,
      width: '500px',
      data: {
        header: 'Are you sure you want to delete this Load Number?',
        description: "Load Number : " + data.loadNumber,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'ConfirmEvent') { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)

        this.homeService.deleteRecord(data.loadNumber.toString()).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.refreshData();
            }
            else {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
            }
          }, error => {
            console.info(error)
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }
        );
      }
    });
  }

  refreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.homeService.loadDataEboiDailyExpedite().subscribe(
      response => {
        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
      },
      error => {
        console.info(error)
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
      {
        linkData = this.displayRowData
      }
      linkData.forEach(e => {
        const obj = {
          LoadNumber: e.loadNumber,
          expDate: e.expediteDate,
          routeDate: e.routeDate,
          route: e.route,
          run: e.run,
          mileage: e.mileage,
          costCentre: e.costCentre,
          allocationRate: e.allocationRate,
          totalCost: e.totalCost,
          domicile: e.domicile,
          reasonId: e.reasonId,
          vendor: e.carrier,
        };
        exportData.push(obj);
      });

      const headers = ['Load Number', 'Expedite Date', 'Route Date', 'Route', 'Run', 'Mileage', 'Cost Center', 'Allocation Rate', 'Total Cost',
        'Domicile', 'Reason ID', 'Vendor'];
      this.excelService.exportAsExcelFile(exportData, 'DAILY EXPEDITE', headers);
      this.ngxUiLoaderService.stop(this.constants.LoaderInitializer)
    }
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
 

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }
 goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

	onPageSizeChanged(event: any) { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails(); }

	getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
  

}


function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 10) { // NOSONAR
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
